import { actions } from './constants.js';

const reducerAfterware = ({
  state,
  action,
  onFiltersChange,
  onIntermediateFiltersChange,
  onOpenStateChange
}) => {
  if (action.type === actions.filters.save) {
    onFiltersChange(state.appliedFilters);
  }
  if (onIntermediateFiltersChange && Object.values(actions.filters).includes(action.type)) {
    onIntermediateFiltersChange(state.toBeAppliedFilters);
  }
  if (onOpenStateChange && action.type === actions.drawer.opened) {
    onOpenStateChange(true);
  }
  const isFilterPanelClosed = action.type === actions.drawer.closed || action.type === actions.filters.dismiss;
  if (onOpenStateChange && isFilterPanelClosed) {
    onOpenStateChange(false);
  }
};

export { reducerAfterware };
